import request from '@/utils/request'

const prefix = '/django_rest/company/applicant-status-auto-change-config'

export default {
  getCompanyApplicantStatusAutoChangeConfig (companyId, params) {
    return request.get(`${prefix}/${companyId}/`, { params })
  },
  createApplicantStatusAutoChangeConfig (companyId, config) {
    return request.post(`${prefix}/${companyId}/`, config)
  },
  updateApplicantStatusAutoChangeConfig (companyId, config) {
    return request.put(`${prefix}/${companyId}/`, config)
  },
  deleteApplicantStatusAutoChangeConfig (companyId) {
    return request.delete(`${prefix}/${companyId}/`)
  }
}
